declare namespace $ {

	type $mol_check_group__title_shm_check_list_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_group['title'] >
	>
	type $mol_check_group__checks_shm_check_list_2 = $mol_type_enforce<
		ReturnType< $shm_check_list['checks'] >
		,
		ReturnType< $mol_check_group['checks'] >
	>
	type $mol_list__rows_shm_check_list_3 = $mol_type_enforce<
		ReturnType< $shm_check_list['checks'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_check_box__title_shm_check_list_4 = $mol_type_enforce<
		ReturnType< $shm_check_list['check_title'] >
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_check_list_5 = $mol_type_enforce<
		ReturnType< $shm_check_list['checked'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	export class $shm_check_list extends $mol_list {
		All( ): $mol_check_group
		checks( ): readonly(any)[]
		Checks( ): $mol_list
		check_title( id: any): string
		checked( id: any, next?: boolean ): boolean
		options( ): readonly(string)[]
		value( next?: readonly(string)[] ): readonly(string)[]
		rows( ): readonly(any)[]
		Check( id: any): $mol_check_box
	}
	
}

//# sourceMappingURL=list.view.tree.d.ts.map